/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

import type { ProductJsonLd } from '../lib/products.ts'

const CONVERSION_EVENTS = {
  VIEW_PDP: 'VIEW_PDP',
  CLICK_BUY_NOW: 'CLICK_BUY_NOW',
  CLICK_SHOP_LINK: 'CLICK_SHOP_LINK',
  CLICK_FIND_DEALER: 'CLICK_FIND_DEALER',
  SEARCH_POS: 'SEARCH_POS',
  SEARCH: 'SEARCH',
  SUBMIT_CONTACT_FORM: 'SUBMIT_CONTACT_FORM',
} as const

function postConversion(
  path: string,
  body: Record<string, unknown>,
): Promise<Response> {
  return fetch(path, {
    method: 'POST',
    body: JSON.stringify({ ...body, url: window.location.toString() }),
  })
}

export function initConversions() {
  window.trackViewPdp = async ({ product }) => {
    window.dispatchEvent(
      new CustomEvent(CONVERSION_EVENTS.VIEW_PDP, { detail: { product } }),
    )
    await postConversion('/conversions/view-pdp', { product })
  }

  window.trackClickBuyNow = async ({ product }) => {
    window.dispatchEvent(
      new CustomEvent(CONVERSION_EVENTS.CLICK_BUY_NOW, {
        detail: { product },
      }),
    )
    await postConversion('/conversions/click-buy-now', { product })
  }

  window.trackClickFindDealer = async ({ product }) => {
    window.dispatchEvent(
      new CustomEvent(CONVERSION_EVENTS.CLICK_FIND_DEALER, {
        detail: { product },
      }),
    )
  }

  window.trackClickShopLink = async ({ product, shopLink }) => {
    window.dispatchEvent(
      new CustomEvent(CONVERSION_EVENTS.CLICK_SHOP_LINK, {
        detail: { product, shopLink },
      }),
    )
    await postConversion('/conversions/click-shop-link', { product, shopLink })
  }

  window.trackSearchPos = async ({ product, search }) => {
    window.dispatchEvent(
      new CustomEvent(CONVERSION_EVENTS.SEARCH_POS, {
        detail: { product, search },
      }),
    )
    await postConversion('/conversions/track-search-pos', { search })
  }

  window.trackSearch = async ({ search }) => {
    window.dispatchEvent(
      new CustomEvent(CONVERSION_EVENTS.SEARCH, { detail: { search } }),
    )
    await postConversion('/conversions/track-search', { search })
  }

  window.trackSubmitContactForm = async ({ product }) => {
    window.dispatchEvent(
      new CustomEvent(CONVERSION_EVENTS.SUBMIT_CONTACT_FORM, {
        detail: { product },
      }),
    )
    await postConversion('/conversions/track-submit-contact-form', { product })
  }
}

declare global {
  interface Window {
    trackViewPdp: (params: { product: ProductJsonLd }) => Promise<void>
    trackClickBuyNow: (params: { product: ProductJsonLd }) => Promise<void>
    trackClickFindDealer: (params: { product: ProductJsonLd }) => Promise<void>
    trackClickShopLink: (
      params: { product: ProductJsonLd; shopLink: string },
    ) => Promise<void>
    trackSearchPos: (
      params: { product: ProductJsonLd; search: string },
    ) => Promise<void>
    trackSearch: (params: { search: string }) => Promise<void>
    trackSubmitContactForm: (
      params: { product: ProductJsonLd },
    ) => Promise<void>
  }
}
